export default __webpack_public_path__ + "media/images/favicon/android-chrome-512x512-ac9086a12ec692428baabc4a3e73a615.png";